import styled from "styled-components";
import { colors } from "colors";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextAreaElement = styled.textarea`
  padding: 10px;
  border: 1px solid ${colors.silver};
  border-radius: 4px;
  outline: none;
  resize: none;
  font-size: 14px;
  font-family: 'Open Sans', 'Helvetica', arial, sans-serif;

  ::placeholder {
    color: ${colors.silver};
    font-size: 14px;
  }
  &[disabled] {
    border: none;
    background-color: ${colors.alabaster};
  }
  &[data-error="true"] {
    border: 1px solid ${colors.strawberry};
  }
`;

export const Label = styled.label`
  font-size: 14px;
  color: ${colors.slateGrey};

  &[required] {
    ::after {
      content: " *";
      color: ${colors.strawberry};
    }
  }
`;
